module.exports = __webpack_public_path__ + "media/images/video/cyclebar-go-logo-fd8f1ae0ca18eaa5115a39a018aa5282.png";